import { render } from "./TagPicker.vue?vue&type=template&id=0ff4441d&ts=true"
import script from "./TagPicker.vue?vue&type=script&lang=ts"
export * from "./TagPicker.vue?vue&type=script&lang=ts"

import "./TagPicker.vue?vue&type=style&index=0&id=0ff4441d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__